import { Box, Typography } from "@mui/material";
import { Reorder } from "framer-motion";
import {
  DotsSixVertical,
  GlobeHemisphereWest,
  Info,
  TextT,
} from "phosphor-react";
import React from "react";
import commonStyles from "../../../Utils/commonStyles";

const SingleTableView = ({ items, onReorder }) => {
  const commonClasses = commonStyles();
  return (
    <Box sx={{ mt: 2 }}>
      <Box className={commonClasses.flexAndGap8Px}>
        <Typography>Table View</Typography>
      </Box>
      {items?.length ? (
        <Box
          sx={{
            overflowX: "auto",
            overflowY: "visible",
            marginTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Reorder.Group
            axis="x"
            values={items}
            onReorder={(newOrder) => {
              if (onReorder) {
                onReorder(newOrder);
              }
              console.log("New order:", newOrder);
            }}
            role="list"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              paddingLeft: "0px",
              listStyle: "none",
              width: "max-content",
              minHeight: "80px",
            }}
          >
            {items.map((item) => (
              <Reorder.Item
                drag
                key={item.id}
                value={item}
                role="listitem"
                style={{
                  cursor: "grab",
                  flexShrink: 0,
                  minWidth: "fit-content",
                }}
                whileDrag={{
                  scale: 1.05,
                  zIndex: 1000,
                }}
              >
                <Box
                  sx={{
                    border: "1px solid #606479",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      backgroundColor: "#252A38",
                      padding: "8px 10px",
                    }}
                  >
                    {item.type === "string" ? (
                      <TextT size={20} style={{ color: "white" }} />
                    ) : (
                      <GlobeHemisphereWest
                        size={20}
                        style={{ color: "white" }}
                      />
                    )}
                    <Typography>{item.name}</Typography>
                    <DotsSixVertical />
                  </Box>
                  <Box sx={{ backgroundColor: "#1B1D28", padding: "4px 10px" }}>
                    <Typography>Other Here</Typography>
                  </Box>
                </Box>
              </Reorder.Item>
            ))}
          </Reorder.Group>
        </Box>
      ) : (
        <Box
          className={commonClasses.flexAndGap8Px}
          sx={{ mt: 2, ml: 1, color: "gray" }}
        >
          <Info size={20} />
          <Typography>Select fields to add them to preview</Typography>
        </Box>
      )}
    </Box>
  );
};

export default SingleTableView;
